import { accountProfileApi } from '../services/api';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Collapse, Navbar, NavbarBrand, NavbarToggler } from 'reactstrap';
import { getUser } from '../services/auth';
import './NavMenu.css';

const clinicalEntries = [
  { path: '/', icon: 'home', label: 'Oggi', exact: true },
  { path: '/patients', icon: 'patients', label: 'Cartelle pazienti' },
  { path: '/copilot', icon: 'spark', label: 'Chiedi a Sibilla' },
  { path: '/visits/new', icon: 'visit', label: 'Avvia visita', matches: ['/visits/new', '/bia'], action: true }
];

const studioEntries = [
  { path: '/agenda', icon: 'calendar', label: 'Agenda' },
  { path: '/diets', icon: 'plan', label: 'Piani' },
  { path: '/sistema-ts', icon: 'receipt', label: 'Sistema TS' }
];

function NavIcon({ name }) {
  const paths = {
    home: <><path d="M3.5 10.5 12 3l8.5 7.5"/><path d="M5.5 9.5V21h13V9.5M9.5 21v-7h5v7"/></>,
    patients: <><circle cx="9" cy="8" r="3.25"/><path d="M3.5 20v-1.5A5.5 5.5 0 0 1 9 13h.5a5.5 5.5 0 0 1 5.5 5.5V20"/><path d="M15 5.5a3.25 3.25 0 0 1 0 6.5M17.5 14a5 5 0 0 1 3 4.5V20"/></>,
    spark: <><path d="m12 3 1.35 4.15L17.5 8.5l-4.15 1.35L12 14l-1.35-4.15L6.5 8.5l4.15-1.35L12 3Z"/><path d="m18.5 14 .75 2.25L21.5 17l-2.25.75L18.5 20l-.75-2.25L15.5 17l2.25-.75L18.5 14ZM5 14l.55 1.45L7 16l-1.45.55L5 18l-.55-1.45L3 16l1.45-.55L5 14Z"/></>,
    visit: <><path d="M7 3v4M17 3v4M4 9h16"/><rect x="4" y="5" width="16" height="16" rx="2.5"/><path d="M12 12v6M9 15h6"/></>,
    calendar: <><path d="M7 3v4M17 3v4M4 9h16"/><rect x="4" y="5" width="16" height="16" rx="2.5"/><path d="M8 13h3M13 13h3M8 17h3M13 17h3"/></>,
    plan: <><path d="M7 4h10M7 8h10M6 3v18h12V3H6Z"/><path d="M9 13h6M9 17h4"/></>,
    receipt: <><path d="M6 3h12v18l-3-2-3 2-3-2-3 2V3Z"/><path d="M9 8h6M9 12h6M9 16h3"/></>,
    settings: <><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.7 1.7 0 0 0 .34 1.88l.06.06-2.86 2.86-.06-.06A1.7 1.7 0 0 0 15 19.4a1.7 1.7 0 0 0-1 .6 1.7 1.7 0 0 0-.4 1V21H9.55v-.09a1.7 1.7 0 0 0-1.1-1.51 1.7 1.7 0 0 0-1.88.34l-.06.06-2.86-2.86.06-.06A1.7 1.7 0 0 0 4.05 15a1.7 1.7 0 0 0-.6-1 1.7 1.7 0 0 0-1-.4H2.4V9.55h.09A1.7 1.7 0 0 0 4 8.45a1.7 1.7 0 0 0-.34-1.88l-.06-.06 2.86-2.86.06.06A1.7 1.7 0 0 0 8.4 4.05a1.7 1.7 0 0 0 1-.6 1.7 1.7 0 0 0 .4-1V2.4h4.05v.09A1.7 1.7 0 0 0 15 4a1.7 1.7 0 0 0 1.88-.34l.06-.06 2.86 2.86-.06.06A1.7 1.7 0 0 0 19.4 8.4a1.7 1.7 0 0 0 .6 1 1.7 1.7 0 0 0 1 .4h.09v4.05H21a1.7 1.7 0 0 0-1.6 1.15Z"/></>,
    logout: <><path d="M10 5H5v14h5M14 8l4 4-4 4M9 12h9"/></>
  };

  return <svg className="app-nav-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">{paths[name]}</svg>;
}

function NavGroup({ label, entries, isActive, onNavigate }) {
  return <div className="app-link-group" aria-label={label}>
    <span className="app-link-group-label">{label}</span>
    {entries.map(entry => <Link
      key={entry.path}
      to={entry.path}
      onClick={onNavigate}
      aria-current={isActive(entry) ? 'page' : undefined}
      className={`${isActive(entry) ? 'active' : ''}${entry.action ? ' app-nav-action' : ''}`}
    >
      <NavIcon name={entry.icon}/>
      <span>{entry.label}</span>
      {entry.action && <small>Scegli il paziente</small>}
    </Link>)}
  </div>;
}

export function NavMenu({ onLogout }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const user = getUser();
  const [studioName,setStudioName]=useState('');
  useEffect(()=>{let active=true;accountProfileApi.get().then(r=>{if(active)setStudioName(r.profile?.displayName||'');}).catch(()=>{});return()=>{active=false;};},[]);
  const organizationEntries = user?.role === 'Admin'
    ? [...studioEntries, { path: '/administration', icon: 'settings', label: 'Amministrazione' }]
    : studioEntries;
  const isActive = entry => {
    if (entry.exact) return location.pathname === entry.path;
    if (entry.matches) return entry.matches.some(path => location.pathname.startsWith(path));
    return location.pathname.startsWith(entry.path);
  };
  const closeMenu = () => setOpen(false);

  return <header className="app-nav-shell">
    <Navbar expand="xl" className="app-nav" container>
      <NavbarBrand tag={Link} to="/" onClick={closeMenu} className="app-brand" aria-label="Sibilla, vai alla panoramica di oggi">
        <span aria-hidden="true">S</span><div>Sibilla<small>Studio nutrizionale</small></div>
      </NavbarBrand>
      <NavbarToggler onClick={() => setOpen(!open)} aria-label={open ? 'Chiudi navigazione' : 'Apri navigazione'} aria-expanded={open} aria-controls="sibilla-main-navigation"/>
      <Collapse id="sibilla-main-navigation" isOpen={open} navbar>
        <nav className="app-links" aria-label="Navigazione principale">
          <NavGroup label="Percorso clinico" entries={clinicalEntries} isActive={isActive} onNavigate={closeMenu}/>
          <NavGroup label="Organizzazione studio" entries={organizationEntries} isActive={isActive} onNavigate={closeMenu}/>
        </nav>
        <div className="app-user">
          <div><strong>{studioName || user?.name || 'Professionista'}</strong><small>{user?.email}</small></div>
          <button type="button" onClick={onLogout} title="Esci da Sibilla" aria-label="Esci da Sibilla"><NavIcon name="logout"/></button>
        </div>
      </Collapse>
    </Navbar>
  </header>;
}

export default NavMenu;
